export const actions = {
    GET_SUBSCRIPTION_PLAN_DETAILS: 'GET_SUBSCRIPTION_PLAN_DETAILS',
    GET_SUBSCRIPTION_PAYMENT_METHODS: 'GET_SUBSCRIPTION_PAYMENT_METHODS',
    GET_SUBSCRIPTION_PAYMENT_METHODS_SUCCESS: 'GET_SUBSCRIPTION_PAYMENT_METHODS_SUCCESS',
    GET_SUBSCRIPTION_PAYMENT_METHODS_FAILED: 'GET_SUBSCRIPTION_PAYMENT_METHODS_FAILED',
    GET_SUBSCRIPTION_PLAN_DETAILS_SUCCESS: 'GET_SUBSCRIPTION_PLAN_DETAILS_SUCCESS',
    GET_SUBSCRIPTION_PLAN_DETAILS_FAILED: 'GET_SUBSCRIPTION_PLAN_DETAILS_FAILED',
    SIGNUP_NEW_SUBSCRIPTION: 'SIGNUP_NEW_SUBSCRIPTION',
    SIGNUP_NEW_SUBSCRIPTION_SUCCESS: 'SIGNUP_NEW_SUBSCRIPTION_SUCCESS',
    SIGNUP_NEW_SUBSCRIPTION_FAILED: 'SIGNUP_NEW_SUBSCRIPTION_FAILED',
    UPDATE_SUBSCRIPTION_PAYMENT: 'UPDATE_SUBSCRIPTION_PAYMENT',
    UPDATE_SUBSCRIPTION_PAYMENT_SUCCESS: 'UPDATE_SUBSCRIPTION_PAYMENT_SUCCESS',
    UPDATE_SUBSCRIPTION_PAYMENT_FAILED: 'UPDATE_SUBSCRIPTION_PAYMENT_FAILED',
    SELECT_SUBSCRIPTION_CARD: 'SELECT_SUBSCRIPTION_CARD',
    GET_SUBSCRIPTION_RENEWALS: 'GET_SUBSCRIPTION_RENEWALS',
    GET_SUBSCRIPTION_RENEWALS_SUCCESS: 'GET_SUBSCRIPTION_RENEWALS_SUCCESS',
    GET_SUBSCRIPTION_RENEWALS_FAILED: 'GET_SUBSCRIPTION_RENEWALS_FAILED',
    CANCEL_SUBSCRIPTION: 'CANCEL_SUBSCRIPTION',
    CANCEL_SUBSCRIPTION_SUCCESS: 'CANCEL_SUBSCRIPTION_SUCCESS',
    CANCEL_SUBSCRIPTION_FAILED: 'CANCEL_SUBSCRIPTION_FAILED',
    GET_SUBSCRIPTION_PROMO_PRODUCTS: 'GET_SUBSCRIPTION_PROMO_PRODUCTS',
    GET_SUBSCRIPTION_PROMO_PRODUCTS_SUCCESS: 'GET_SUBSCRIPTION_PROMO_PRODUCTS_SUCCESS',
    GET_SUBSCRIPTION_PROMO_PRODUCTS_FAILED: 'GET_SUBSCRIPTION_PROMO_PRODUCTS_FAILED',
    REACTIVATE_SUBSCRIPTION: 'REACTIVATE_SUBSCRIPTION',
    REACTIVATE_SUBSCRIPTION_SUCCESS: 'REACTIVATE_SUBSCRIPTION_SUCCESS',
    REACTIVATE_SUBSCRIPTION_FAILED: 'REACTIVATE_SUBSCRIPTION_FAILED',
    FAILED_SUBSCRIPTION_PAYMENT: 'FAILED_SUBSCRIPTION_PAYMENT',
    CLEAR_ACTION_STATUS: 'CLEAR_ACTION_STATUS',
    RESET_SUBSCRIPTIONS: 'RESET_SUBSCRIPTIONS',

    SET_SHOW_FAILED_SUBSCRIPTION_PAYMENT_MODAL: 'SET_SHOW_FAILED_SUBSCRIPTION_PAYMENT_MODAL',
    SET_SHOW_DELETE_SUBSCRIPTION_CARD_MODAL: 'SET_SHOW_DELETE_SUBSCRIPTION_CARD_MODAL',
}

export const getSubscriptionPlanDetails = payload => ({
    type: actions.GET_SUBSCRIPTION_PLAN_DETAILS,
    payload,
})

export const getSubscriptionPaymentMethods = () => ({
    type: actions.GET_SUBSCRIPTION_PAYMENT_METHODS,
})

export const getSubscriptionPaymentMethodsSuccess = payload => ({
    type: actions.GET_SUBSCRIPTION_PAYMENT_METHODS_SUCCESS,
    payload,
})

export const getSubscriptionPaymentMethodsFailed = () => ({
    type: actions.GET_SUBSCRIPTION_PAYMENT_METHODS_FAILED,
})

export const getSubscriptionPlanDetailsSuccess = details => ({
    type: actions.GET_SUBSCRIPTION_PLAN_DETAILS_SUCCESS,
    payload: details,
})

export const getSubscriptionPlanDetailsFailed = () => ({
    type: actions.GET_SUBSCRIPTION_PLAN_DETAILS_FAILED,
})

export const signupNewSubscription = payload => ({
    type: actions.SIGNUP_NEW_SUBSCRIPTION,
    payload,
})

export const signupNewSubscriptionSuccess = payload => ({
    type: actions.SIGNUP_NEW_SUBSCRIPTION_SUCCESS,
    payload,
})

export const signupNewSubscriptionFailed = payload => ({
    type: actions.SIGNUP_NEW_SUBSCRIPTION_FAILED,
    payload,
})

export const updateSubscriptionPayment = payload => ({
    type: actions.UPDATE_SUBSCRIPTION_PAYMENT,
    payload,
})

export const updateSubscriptionPaymentSuccess = payload => ({
    type: actions.UPDATE_SUBSCRIPTION_PAYMENT_SUCCESS,
    payload,
})

export const updateSubscriptionPaymentFailed = payload => ({
    type: actions.UPDATE_SUBSCRIPTION_PAYMENT_FAILED,
    payload,
})

export const selectSubscriptionCard = card => ({
    type: actions.SELECT_SUBSCRIPTION_CARD,
    payload: card,
})

export const getSubscriptionRenewals = payload => ({
    type: actions.GET_SUBSCRIPTION_RENEWALS,
    payload,
})

export const getSubscriptionRenewalsSuccess = response => ({
    type: actions.GET_SUBSCRIPTION_RENEWALS_SUCCESS,
    payload: response,
})

export const getSubscriptionRenewalsFailed = error => ({
    type: actions.GET_SUBSCRIPTION_RENEWALS_FAILED,
    payload: error,
})

export const cancelSubscription = payload => ({
    type: actions.CANCEL_SUBSCRIPTION,
    payload,
})

export const cancelSubscriptionSuccess = response => ({
    type: actions.CANCEL_SUBSCRIPTION_SUCCESS,
    payload: response,
})

export const cancelSubscriptionFailed = error => ({
    type: actions.CANCEL_SUBSCRIPTION_FAILED,
    payload: error,
})

export const getSubscriptionPromoProducts = payload => ({
    type: actions.GET_SUBSCRIPTION_PROMO_PRODUCTS,
    payload,
})

export const getSubscriptionPromoProductsSuccess = response => ({
    type: actions.GET_SUBSCRIPTION_PROMO_PRODUCTS_SUCCESS,
    payload: response,
})

export const getSubscriptionPromoProductsFailed = response => ({
    type: actions.GET_SUBSCRIPTION_PROMO_PRODUCTS_FAILED,
    payload: response,
})

export const reactivateSubscription = payload => ({
    type: actions.REACTIVATE_SUBSCRIPTION,
    payload,
})

export const reactivateSubscriptionSuccess = response => ({
    type: actions.REACTIVATE_SUBSCRIPTION_SUCCESS,
    payload: response,
})

export const reactivateSubscriptionFailed = error => ({
    type: actions.REACTIVATE_SUBSCRIPTION_FAILED,
    payload: error,
})

export const failedSubscriptionPayment = payload => ({
    type: actions.FAILED_SUBSCRIPTION_PAYMENT,
    payload,
})

export const clearActionStatus = payload => ({
    type: actions.CLEAR_ACTION_STATUS,
    payload,
})

export const setShowFailedSubscriptionPaymentModal = payload => ({
    type: actions.SET_SHOW_FAILED_SUBSCRIPTION_PAYMENT_MODAL,
    payload,
})

export const setShowDeleteSubscriptionCardModal = payload => ({
    type: actions.SET_SHOW_DELETE_SUBSCRIPTION_CARD_MODAL,
    payload,
})

export const resetSubscriptions = payload => ({
    type: actions.RESET_SUBSCRIPTIONS,
    payload,
})
